module.exports = __webpack_public_path__ + "img/1881_FIX2 (Large).382b6238.jpg";